module.exports = __webpack_public_path__ + "media/country_flags/je-76ce0aa4.png";